<template>
  <component
          :is="exist? 'a' : 'b-button'"
          class="btn btn-dark product-page__order-block-btn"
          :disabled="!selected || loading"
          @click="buy"
          :href="exist? `/${$currentLang}/cart` : ''"
  >
    <b-spinner small v-if="loading"></b-spinner>
    <span v-else>{{exist ? 'In cart' : 'Place order'}}</span>
  </component>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CatalogAddButton',
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters('shop_card', ['item', 'selected', 'list']),
    exist () {
      return this.list.findIndex(product => this.item.id === product.id && this.selected.id === product.material.id) !==
        -1
    },
  },
  methods: {
    ...mapActions('shop_card', ['store']),
    buy () {
      if (!this.exist)
      {
        this.loading = true
        this.store([...this.list, { ...this.item, material: this.selected }]).finally(() => this.loading = false)
      }
    },
  },
}
</script>

<style scoped>
.product-page__order-block-btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
